import { keepPreviousData, useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";
import {
  FeatureAdoptionData,
  FeatureAdoptionQuery,
} from "@reflag/shared/featureAPI";

dayjs.extend(utc);

export function useFeatureAdoptionData(
  featureId: string,
  params: Omit<FeatureAdoptionQuery, "envId">,
  live = false,
) {
  const { appId, envId } = useEnvironment();
  const adoptionParams: FeatureAdoptionQuery = {
    envId,
    ...params,
  };

  return useQuery<FeatureAdoptionData>({
    queryKey: featureQueryKeys.singleAdoption(
      appId,
      envId,
      featureId,
      adoptionParams,
    ),
    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/metrics">(
          `/apps/${appId}/features/${featureId}/metrics`,
          {
            params: {
              envId: envId!,
              ...params,
            },
          },
        )
        .then((res) => res.data),
    refetchInterval: live ? 1000 * 2 : false,
    placeholderData: keepPreviousData,
  });
}
